export default __webpack_public_path__ + "static/media/gallery-image-2-full.3509fe30.jpg";